/**
 * „Wyślij do CEEB z nieobecnościami" (właściciel 2026-10-21, Bolesława Prusa 28): budynek, w którym praca w terenie
 * skończyła się nieobecnościami / odmowami lokatora, a nic innego nie czeka na CEEB. Lokale bez wejścia idą do CEEB
 * WYŁĄCZNIE zdaniem w „Uwagach" (3. strona protokołu); serwer zawsze zapisuje wersję roboczą — wystawia człowiek.
 * Decyduje serwer (ceebPushQuery.planInaccessiblePush) — tu tylko widoczność przycisku i treść okna.
 */
import type { PipelineBuilding } from '../services/api';

/** Etapy, na których przycisk ma sens (lustro INACCESSIBLE_PUSH_STAGES w backendzie). */
export const INACCESSIBLE_PUSH_STAGES = ['DO_POWROTU', 'GOTOWY_DO_CEEB'];

type Row = Pick<PipelineBuilding, 'lifecycle_state' | 'apt_total' | 'apt_terminal' | 'apt_open' | 'apt_pending_ceeb'
  | 'ceebStatus' | 'inaccessiblePendingCeeb'>;

/**
 * Przycisk widoczny, gdy: etap „Do powrotu"/„Gotowy do CEEB", każdy lokal ma wynik (terminalny albo nieobecność /
 * odmowa lokatora), nic terminalnego nie czeka na CEEB (wtedy zwykły „Wyślij do CEEB"), są nieobecności poza CEEB,
 * a protokół nie jest wystawiony.
 */
export function canPushInaccessible(b: Row): boolean {
  const nieobecne = b.inaccessiblePendingCeeb ?? [];
  return INACCESSIBLE_PUSH_STAGES.includes(b.lifecycle_state)
    && b.apt_total > 0
    && b.apt_terminal + b.apt_open === b.apt_total
    && b.apt_pending_ceeb === 0
    && nieobecne.length > 0
    && b.ceebStatus !== 'Wprowadzony' && b.ceebStatus !== 'Zaakceptowany';
}

/**
 * Zdanie, które bot wpisze do „Uwag" — LUSTRO backendu `constants/recommendations.buildInaccessibleSentence`
 * (format Bronka: bez spacji po „nr.:", przecinki bez spacji, liczba pojedyncza/mnoga). Ten sam literał pinują testy
 * po obu stronach (ceebInaccessiblePush.test.js / ceebInaccessiblePush.test.ts).
 */
export function inaccessibleSentenceText(numbers: string[]): string {
  if (!numbers.length) return '';
  const rzeczownik = numbers.length === 1 ? 'lokalu' : 'lokali';
  return `Z powodu nieobecności lokatorów do kontroli nie udostępniono ${rzeczownik} nr.:${numbers.join(',')}.`;
}
